export class SessionDetail {
    employeeId: any;
    firstName: any;
    lastName: any;
    userType: any;
}
